/* eslint-disable max-len */
import { Component, AfterViewInit, ViewChild, Inject, Input, OnDestroy } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { ActionSheetController, IonInfiniteScroll, IonVirtualScroll, ModalController, NavController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { GroupService } from 'src/app/services/group.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { ShareService } from 'src/app/services/share.service';
import { environment } from 'src/environments/environment';
import { LedgerService } from 'src/app/services/ledger.service';
import { SquareService } from 'src/app/services/square.service';
import firebase from 'firebase/app';
import 'firebase/firestore';

@Component({
  selector: 'app-feeds',
  templateUrl: './feeds.component.html',
  styleUrls: ['./feeds.component.scss'],
})
export class FeedsComponent implements AfterViewInit, OnDestroy {

  @ViewChild(IonVirtualScroll) virtualScroll: IonVirtualScroll;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;

  @Input() public id: any;
  @Input() public groupId: any;
  @Input() public squareId: any;
  @Input() public search: any;
  @Input() public disableFilter: boolean;

  articles = [];
  tapCount = 0;
  subjects = [];
  subjectlist = ['Physics', 'Chemistry', 'Biology', 'General Science', 'Maths', 'Hindi', 'English', 'Urdu', 'Sanskrit', 'Language', 'Literature', 'Economics', 'Civics', 'Geography', 'History', 'Arts', 'Law', 'Accounts', 'Business Studies', 'Physical Activities', 'Engineering', 'Medical Science', 'Environmental Science', 'Computer Science', 'Energy Science', 'Pharmacy', 'Product Designing', 'Manufacturing', 'Programming', 'Philosophy', 'Psychology', 'Drawing', 'CAD Designing', 'Thermodynamics', 'Quantum Mechanics', 'Mechanics', 'Sociology', 'Entrepreneurship', 'Mechanical Engineering', 'Electrical Engineering', 'Civil Engineering', 'Statistics', 'Artificial Intelligence', 'Aerospace', 'Others'];
  tab = 'all';
  endReached;
  myEndReached;
  currentUser = this.authService.currentUser;
  unsub1;
  constructor(
    public firestore: AngularFirestore,
    public authService: AuthService,
    public navController: NavController,
    public actionSheetController: ActionSheetController,
    public notificationsService: NotificationsService,
    public modalController: ModalController,
    public groupService: GroupService,
    public shareService: ShareService,
    public ledgerService: LedgerService,
    public squareService: SquareService
  ) {
    window.addEventListener('refresh-articles', async () => {
      console.log('=====>>>>> refresh-articles');
      this.getArticles(undefined);
    });
    this.unsub1 = this.authService.currentAccount.subscribe(async (user) => {
      if (user) {
        this.currentUser = user;
      }
    });
  }


  ngAfterViewInit() {
    this.getArticles(undefined);
  }

  async getArticles(more: boolean) {
    const limitCount = 50;
    const query = this.firestore.collection('articles', ref => {
      let q: any = ref;

      if (this.search && this.search.trim() !== '') {
        q = q.where('search', 'array-contains', this.search.toLowerCase()).orderBy('search');
      } else {
        q = q.orderBy('timestamp', 'desc');
      }

      if (this.id) {
        q = q.where('user', '==', this.id);
      }
      if (this.groupId) {
        q = q.where('groupId', '==', this.groupId);
      }
      if (this.squareId) {
        q = q.where('squareId', '==', this.squareId);
      }
      if (this.subjects.length > 0) {
        q = q.where('subjects', 'array-contains-any', this.subjects);
      }
      if (this.tab !== 'all') {
        q = q.where('type', '==', this.tab);
      }

      return q.limit(limitCount);
    });

    if (!more) {
      this.endReached = false;
      if (this.infiniteScroll) {
        this.infiniteScroll.disabled = false;
      }
      const articles = this.articles = [];
      const documentSnapshots = await query.get().toPromise();
      for (const docRef of documentSnapshots.docs) {
        const article: any = { id: docRef.id, ...((docRef.data() as any) || {}) };
        if (article.user) {
          article.user = await this.authService.getUserById(article.user);
        }
        if (article.groupId) { article.group = await this.groupService.getGroupOnce(article.groupId); }
        if (article.groupId) { article.isCurrentGroupPost = article.groupId === this.groupId; }
        if (article.squareId) { article.square = await this.squareService.getSquareOnce(article.squareId); }
        if (article?.square?.group) { article.square.group = await this.groupService.getGroupOnce(article.square.group); }
        if (article.squareId) { article.isCurrentSquarePost = article.squareId === this.squareId; }
        articles.push(article);
      }
      this.articles.push(...articles);
      if (this.virtualScroll) { this.virtualScroll.checkEnd(); }
    } else {
      // For pagination, we'll need to implement a different approach
      // since AngularFire doesn't support startAfter in the same way
      const lastVisible = this.articles[this.articles.length - 1];
      if (lastVisible && !this.endReached) {
        // Simple pagination by skipping already loaded items
        const skipCount = this.articles.length;
        const paginatedQuery = this.firestore.collection('articles', ref => {
          let q: any = ref;

          if (this.search && this.search.trim() !== '') {
            q = q.where('search', 'array-contains', this.search.toLowerCase()).orderBy('search');
          } else {
            q = q.orderBy('timestamp', 'desc');
          }

          if (this.id) {
            q = q.where('user', '==', this.id);
          }
          if (this.groupId) {
            q = q.where('groupId', '==', this.groupId);
          }
          if (this.squareId) {
            q = q.where('squareId', '==', this.squareId);
          }
          if (this.subjects.length > 0) {
            q = q.where('subjects', 'array-contains-any', this.subjects);
          }
          if (this.tab !== 'all') {
            q = q.where('type', '==', this.tab);
          }

          return q.limit(limitCount + skipCount);
        });

        const documentSnapshots = await paginatedQuery.get().toPromise();
        const newDocs = documentSnapshots.docs.slice(skipCount);

        if (newDocs.length < limitCount) { this.endReached = true; }

        for (const docRef of newDocs) {
          const article: any = { id: docRef.id, ...((docRef.data() as any) || {}) };
          if (article.user) {
            article.user = await this.authService.getUserById(article.user);
          }
          if (article.groupId) { article.group = await this.groupService.getGroupOnce(article.groupId); }
          if (article.groupId) { article.isCurrentGroupPost = article.groupId === this.groupId; }
          if (article.squareId) { article.square = await this.squareService.getSquareOnce(article.squareId); }
          if (article.squareId) { article.isCurrentSquarePost = article.squareId === this.squareId; }
          this.articles.push(article);
        }
      }
    }
  }

  subjectChanged(event: any) {
    this.subjects = event.detail.value;
    this.getArticles(undefined);
  }

  reachedHeader(record: any, recordIndex: number, records: any[]) {
    console.log(record);
    if (record.groupId && record.group && !record.isCurrentGroupPost) {
      return record.group;
    }
    if (record.squareId && record.square && !record.isCurrentSquarePost) {
      return record.square;
    }
    return null;
  }

  reachedFooter(record: any, recordIndex: number, records: any[]) {
    // if (record?.comments?.length > 0) {
    //   if (recordIndex % 1 === 0) {
    //     return record?.comments[0];
    //   }
    // }
    return null;
  }


  async loadData(event: any) {
    if (this.endReached) {
      event.target.complete();
      event.target.disabled = true;
      return;
    }
    // Using settimeout to simulate api call
    if (this.tab === 'all') {
      if (this.articles[this.articles.length - 1]) {
        // load more data
        await this.getArticles(true);
      } else {
        await this.getArticles(undefined);
      }
    }
    //Hide Infinite List Loader on Complete
    event.target.complete();
    //Rerender Virtual Scroll List After Adding New Data
    if (this.virtualScroll) { this.virtualScroll.checkEnd(); }
  }

  segmentChanged(event: any) {
    this.tab = event.detail.value;
    this.getArticles(undefined);
  }

  share(event: any, article: any, type: string) {
    if (this.shareService && article?.id) {
      this.shareService.share(
        article?.searchList?.substring(0, 150) || '',
        article.title || '',
        article.images || [],
        environment.siteUrl + 'article/' + article.id
      );
    }
  }

  gotToArticle(article: any, type: string) {
    const i = this.articles.findIndex(x => x.id === article.id);
    if (this.navController && i >= 0) {
      this.navController.navigateForward(['/article', this.articles[i].id]);
    }
  }

  gotToComment(article: any, type: string) {
    const i = this.articles.findIndex(x => x.id === article.id);
    if (this.navController && i >= 0) {
      this.navController.navigateForward(['/article', this.articles[i].id]);
    }
  }

  async like(article: any, type: string) {
    if (!this.currentUser?.id || !article?.id) {return;}

    if (!article?.likes?.length) { article.likes = []; }
    console.log('like', article, type);
    const i = this.articles.findIndex(x => x.id === article.id);
    const docRef = this.firestore.collection('articles').doc(article.id);

    if (article?.likes?.includes(this.currentUser.id)) {
      // Remove like logic (commented out)
    } else {
      article.likes.push(this.currentUser.id);
      if (i >= 0) {
        this.articles[i] = article;
      }
      docRef.update({
        likes: firebase.firestore.FieldValue.arrayUnion(this.currentUser.id)
      }).then(async () => {
        const docSnap = await docRef.get().toPromise();
        if (docSnap.exists) {
          const updatedArticle = { id: docSnap.id, ...((docSnap.data() as any) || {}) };
          if (updatedArticle.user) {
            updatedArticle.user = await this.authService.getUserById(updatedArticle.user);
          }
          if (i >= 0) {
            this.articles[i] = updatedArticle;
          }
          if (this.articles[i]?.likes?.includes(this.currentUser.id) && this.currentUser?.displayName) {
            console.log('like', updatedArticle, type);
            if (this.notificationsService && updatedArticle?.user?.notificationToken) {
              this.notificationsService.sendNotification(
                this.currentUser.displayName + ' has liked your post',
                updatedArticle.content,
                {
                  notificationToken: updatedArticle?.user?.notificationToken,
                  type: 'notification',
                  by: this.currentUser.id,
                  to: updatedArticle.user.id,
                  redirectURL: '/article/' + updatedArticle.id
                },
                updatedArticle?.images?.length > 0 ? updatedArticle?.images[0] : undefined,
                undefined,
                undefined
              );
            }
          }
        }
      }).catch(err => {
        console.log(err);
      });
    }
  }

  openCardMenu(article: any, type: string) {
    const i = this.articles.findIndex(x => x.id === article.id);
    if (document.getElementById(`ion-card-${i}`)) {
      document.getElementById(`ion-card-${i}`).scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    if (this.presentActionSheet) {
      this.presentActionSheet(article, type);
    }
  }

  async presentActionSheet(article: any, type: string) {
    const i = this.articles.findIndex(x => x.id === article.id);
    if (!this.actionSheetController) {return;}

    const actionSheet = await this.actionSheetController.create({
      header: 'Options',
      cssClass: 'feeds-action-sheet',
      buttons: [{
        text: 'Open',
        icon: 'open-outline',
        cssClass: 'feeds-action-sheet-btn',
        handler: () => {
          console.log('Open clicked');
          if (this.openDetailPage) {
            this.openDetailPage(article, type);
          }
        }
      },
      {
        text: 'Like',
        icon: 'thumbs-up-sharp',
        handler: () => {
          if (this.like) {
            this.like(article, type);
          }
        }
      },
      {
        text: 'Comment',
        icon: 'chatbox-outline',
        handler: () => {
          if (this.gotToComment) {
            this.gotToComment(article, type);
          }
        }
      },

      {
        text: 'Share',
        icon: 'share-outline',
        handler: () => {
          if (this.share) {
            this.share({}, article, type);
          }
        }
      },
      {
        text: 'Delete',
        role: 'destructive',
        icon: 'trash-outline',
        handler: () => {
          if (this.articles[i]?.user?.id === this.currentUser?.id) {
            const docRef = this.firestore.collection('articles').doc(this.articles[i].id);
            docRef.delete();
            const coinCost = { post: -1, question: -5, note: -10, article: -20 };
            if (this.ledgerService && this.currentUser?.id) {
              this.ledgerService.addUserLedger({
                user: this.currentUser.id,
                message: 'Delete Cost',
                value: coinCost[this.articles[i].type] || -1
              });
            }
            if (this.getArticles) {
              this.getArticles(false);
            }
          } else {
            if (this.authService?.presentToast) {
              this.authService.presentToast('This is not your post to delete!');
            }
          }
        }
      },
      // {
      //   text: 'Report',
      //   icon: 'alert-circle-outline',
      //   role: 'destructive',
      //   handler: () => {

      //   }
      // },
      {
        text: 'Cancel',
        icon: 'close-outline',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();
  }

  openDetailPage(article: any, type: string) {
    const i = this.articles.findIndex(x => x.id === article.id);
    if (this.navController && i >= 0) {
      this.navController.navigateForward(['/article', this.articles[i].id]);
    }
  }

  purchaseFile(coin: number, file: string, article: any) {
    if (this.ledgerService && this.authService?.currentUser?.id) {
      this.ledgerService.addUserLedger({
        user: this.authService.currentUser.id,
        message: 'Downloading Cost!',
        value: coin
      }).then(() => {
        if (this.downloadFile) {
          this.downloadFile(file);
        }
      });

      if (article?.user?.id) {
        this.ledgerService.addUserLedger({
          user: article.user.id,
          message: 'Coins earned with upload!',
          value: (-1 * coin / 2)
        });
      }
    }
  }

  downloadFile(file: string) {
    const link: any = document.createElement('a');
    link.download = 'download-sharesquare';
    link.href = file;
    link.style.visibility = 'hidden';
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  ngOnDestroy() {
    if (this.unsub1) {
      this.unsub1.unsubscribe();
    }
    window.removeEventListener('refresh-articles', () => { });
  }
}
